/**
 * @fileoverview Label Component
 *
 * Accessible label component with Tailwind CSS styling.
 * Follows CLAUDE.md guidelines: Tailwind utilities, CVA for variants.
 */

import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { cn } from "@/lib/utils";

const labelVariants = cva(
	"text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

export interface LabelProps
	extends React.LabelHTMLAttributes<HTMLLabelElement>,
		VariantProps<typeof labelVariants> {}

const Label = React.forwardRef<HTMLLabelElement, LabelProps>(
	({ className, ...props }, ref) => {
		return (
			// biome-ignore lint/a11y/noLabelWithoutControl: Generic label component - htmlFor is passed via props
			<label ref={ref} className={cn(labelVariants(), className)} {...props} />
		);
	},
);
Label.displayName = "Label";

export { Label };
